module.exports = __webpack_public_path__ + "static/media/cloud-moon.bdbbd753.svg";